import { useRef } from "react"
import { ChatAiInput } from "@/modules/chats/components/chat-input/chat-ai-input"
import { ChatComposerTextarea } from "@/modules/chats/components/chat-input/chat-composer-textarea"
import { ChatTemplatesBlock } from "@/modules/chats/components/chat-input/chat-templates-block"
import { MagicWandButton } from "@/modules/chats/components/chat-input/magic-wand-button"
import { NextBestQuestionChip } from "@/modules/chats/components/chat-input/next-best-question-chip"
import { SendMessageButtons } from "@/modules/chats/components/chat-input/send-message-buttons"
import { TranslateButton } from "@/modules/chats/components/chat-input/translate-button"
import { UndoRedoButtons } from "@/modules/chats/components/chat-input/undo-redo-buttons"
import { useAutoTranslationGreetingRebuilder } from "@/modules/chats/hooks/useAutoTranslationGreetingRebuilder"
import { useChatInputPrefill } from "@/modules/chats/hooks/useChatInputPrefill"
import { ChatThread } from "@/modules/chats/types/chat-thread"

type ChatInputBodyProps = { selectedThread: ChatThread }
export const ChatInputBody = ({ selectedThread }: ChatInputBodyProps) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null)

  useChatInputPrefill(selectedThread)
  useAutoTranslationGreetingRebuilder(selectedThread)

  return (
    <div className="group group-hover:bg-surface-subdued-hovered relative flex w-full flex-col gap-2">
      <NextBestQuestionChip />
      <div className="flex justify-between">
        <ChatAiInput selectedThread={selectedThread} />
        <ChatTemplatesBlock
          appointmentLanguage={selectedThread.language}
          appointmentService={selectedThread.appointmentService}
          patientCountry={selectedThread.patient.country}
        />
      </div>
      <ChatComposerTextarea selectedThread={selectedThread} textareaRef={textareaRef} />
      <div className="bg-surface-subdued group-hover:bg-surface-subdued-hovered absolute bottom-0 z-10 flex h-11 w-full flex-row items-center justify-between rounded-md border border-t-0 px-3 pt-1 pb-2 transition-all">
        <div className="flex flex-row gap-2">
          <UndoRedoButtons textareaRef={textareaRef} />
          <TranslateButton selectedThread={selectedThread} />
          <MagicWandButton selectedThread={selectedThread} />
        </div>
        <SendMessageButtons selectedThread={selectedThread} textareaRef={textareaRef} />
      </div>
    </div>
  )
}
